import PrintLabel from '@/store/modules/printLabel/constants';
import PrintLabelService from '@/services/PrintLabelService';

const printLabelService = new PrintLabelService();
export default {
  async [PrintLabel.actions.loadPrintLabelInfo]({ commit }, printLabelId) {
    commit(PrintLabel.mutations.setLoading, true);
    let info;
    try {
      info = await printLabelService.getPrintLabelData(printLabelId);
      commit(PrintLabel.mutations.setPrintLabelInfo, JSON.parse(info));
    } catch (exeption) {
      commit(PrintLabel.mutations.setError, exeption.message);
    } finally {
      commit(PrintLabel.mutations.setLoading, false);
    }
  },
};
